import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import { loadAllStaff } from "@/redux/rtk/features/hrm/user/userSlice";
import { useBulkUpdateLeadOwnerMutation } from "@/redux/rtk/features/leads/leadsApi";
import { Button, Form, Select } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import usePermissions from "@/utils/usePermissions";

export default function BulkUpdateLeadOwner({ selectedRowKeys, onClose, clearSelection }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [bulkUpdateLeadOwner, { isLoading }] = useBulkUpdateLeadOwnerMutation();

    const { list: staffList, loading: staffLoading } = useSelector(
        (state) => state.users
    );

    const { permissions } = usePermissions();
    const canReadAllUser = permissions?.includes("readAll-user");

    const currentUserId = localStorage.getItem("id");
    const currentUserName = localStorage.getItem("user");

    const ownerOptions = (canReadAllUser && staffList) ? [...staffList] : [];
    const isCurrentUserInList = ownerOptions.some(item => String(item.id) === String(currentUserId));
    if (!isCurrentUserInList && currentUserId && currentUserName) {
        ownerOptions.push({
            id: parseInt(currentUserId),
            username: currentUserName,
            firstName: "",
            lastName: ""
        });
    }

    useEffect(() => {
        dispatch(loadAllStaff({ query: "all" }));
    }, [dispatch]);

    const onFinish = async (values) => {
        const payload = {
            ids: selectedRowKeys,
            leadOwnerId: values.leadOwnerId,
        };
        const resp = await bulkUpdateLeadOwner(payload);
        if (resp.data) {
            form.resetFields();
            clearSelection();
            onClose();
        }
    };

    return (
        <UserPrivateComponent permission="update-lead">
            <div className="mt-5">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    className="flex flex-col gap-4">
                    <Form.Item
                        label={t("lead.leadOwner")}
                        name="leadOwnerId"
                        rules={[{ required: true, message: t("lead.selectLeadOwner") }]}>
                        <Select
                            style={{ width: "100%" }}
                            loading={staffLoading}
                            allowClear
                            showSearch
                            placeholder={t("lead.selectLeadOwner")}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                            }>
                            {ownerOptions?.map((item) => {
                                const name = item?.firstName || item?.lastName ? `${item.firstName} ${item.lastName}` : "";
                                const label = `${name} (${item?.username || ""})`;
                                return (
                                    <Select.Option key={item.id} value={item.id} label={label}>
                                        {name} ({item?.username})
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    </Form.Item>

                    <div className="flex justify-end gap-2">
                        <Button onClick={onClose}>{t("common.cancel")}</Button>
                        <Button type="primary" htmlType="submit" loading={isLoading}>
                            {t("common.update")}
                        </Button>
                    </div>
                </Form>
            </div>
        </UserPrivateComponent>
    );
}
